module.exports = __webpack_public_path__ + "img/instafame.b341d608.png";